import type { GridRenderCellParams } from "@mui/x-data-grid";
import { IconLinkButton } from "@components";

export const TemplatesActionsCell = (props: GridRenderCellParams<any, any>) => {
  const to = `/validation-rules/edit/${props?.row.id}`;

  return <IconLinkButton to={to} />;
};
